import React, { useState, useEffect } from 'react';
export default (function (props) {
  var _useState = useState(false),
      isStuck = _useState[0],
      setIsStuck = _useState[1];

  var sentinalEl = React.createRef();
  useEffect(function () {
    if (typeof window === 'undefined') return;
    if (!window.IntersectionObserver) return;

    var handler = function handler(entries) {
      setIsStuck(!entries[0].isIntersecting);
    };

    var observer = new window.IntersectionObserver(handler);
    observer.observe(sentinalEl.current);
  }, []);
  return React.createElement(React.Fragment, null, React.createElement('div', {
    ref: sentinalEl
  }), props.render({
    isStuck: isStuck
  }));
});